import * as React from 'react';

interface DefaultSuggestedValueProps {
	suggestedValue: string;
	applySuggestedValue: () => void;
}

/**
 * Default component used to render suggested values.
 * @param param0 props
 */
const DefaultSuggestedValue: React.SFC<DefaultSuggestedValueProps> = ({ suggestedValue, applySuggestedValue }) => (
	<p>
		<em>New suggested value:</em> {suggestedValue}{' '}
		<button
			type="button"
			data-testid="apply-suggested-value-button"
			className="btn btn-xs btn-primary"
			onClick={applySuggestedValue}
		>
			Apply
		</button>
	</p>
);

export default DefaultSuggestedValue;
